// extracted by mini-css-extract-plugin
export default {"Goals":"Goals_Goals__POAlS","GoalElement":"Goals_GoalElement__Yw09e"};